import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { appointmentProgressActions } from '../../../redux/appointmentForm/progress-types';
import { actions as medicationsActions } from '../../../redux/appointmentForm/requests/medications-req';
import {
  selectHealthConditions,
  selectMedicationAllergies,
} from '../../../redux/data/selectors';
import {
  selectProgressCareUser,
  selectMedicationSearchData,
  selectPcpProviderAnswer,
} from '../../../redux/appointmentForm/selectors';

const mapStateToProps = state => ({
  details: selectProgressCareUser(state),
  medicationSearch: selectMedicationSearchData(state),
  healthConditionsList: selectHealthConditions(state),
  medicationAllergiesList: selectMedicationAllergies(state),
  pcpProviderAnswer: selectPcpProviderAnswer(state),
});

const mapDispatchToProps = {
  fetchMedications: medicationsActions.send,
  loadMoreMedications: medicationsActions.loadMore,
  clearMedicationSearch: medicationsActions.clear,
  setHealthInfo: appointmentProgressActions.setHealthInfo,
  updateData: appointmentProgressActions.updateNecessaryData,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/AppointmentForm/AppointmentHealthInformation/enhance.js